export default __webpack_public_path__ + "67b9e0c8beeace638f2e8ccb7ef57148.svg";